import { z } from 'zod';

import { CardSchema } from './card';

export const CardSentimentSchema = z.enum(['positivo', 'neutro', 'frustrado', 'negativo']);

export type CardSentiment = z.infer<typeof CardSentimentSchema>;

/**
 * Card detail read model consumed by the drawer. The v2 drawer header no
 * longer surfaces sentiment / AI confidence / reasons / owner, so the detail
 * is the persisted card plus the read-time `agentDisplayName` (via
 * {@link CardSchema}).
 */
export const CardDetailSchema = CardSchema;

export type CardDetail = z.infer<typeof CardDetailSchema>;
